import Swal from "sweetalert2";

export const commonConfirmBox = async (
  title,
  confirmButtonText,
  cancelButtonText,
  Html = undefined
) => {
  const result = await Swal.fire({
    title: title,
    icon: "info",
    html: Html,
    showCancelButton: true,
    focusConfirm: false,
    confirmButtonText: confirmButtonText ? confirmButtonText : "Yes",
    confirmButtonAriaLabel: "Thumbs up, great!",
    cancelButtonText: cancelButtonText ? cancelButtonText : "No",
    cancelButtonAriaLabel: "Thumbs down",
  });
  return result.isConfirmed;
};

export const commonAleartBox = async (title) => {
  const result = await Swal.fire({
    icon: "error",
    title: title,
    // showCancelButton: true,
  });
  return result.isConfirmed;
};

export const commonOopsBox = async (
  title,
) => {
  const result = await Swal.fire({
    icon: "error",
    title: title,
  });

  return result.isConfirmed;
};



export const commonPromptBox = async ({
  title = "Enter a value",
  label = "", 
  input = "text", // Can be "text", "textarea", "email", "password", etc.
  inputAttributes = {},
  confirmButtonText = "Submit",
  cancelButtonText = "Cancel",
  preConfirm = null,
}) => {
  const result = await Swal.fire({
    title: `<div style="margin-bottom: 12px;font-size: 1.25rem;">${title}</div>${label ? `<div style="font-size: 0.95rem; color: gray;">${label}</div>` : ""}`,
    input,
    inputAttributes,
    showCancelButton: true,
    confirmButtonText,
    cancelButtonText,
    showLoaderOnConfirm: !!preConfirm,
    preConfirm: preConfirm
      ? async (value) => {
          try {
            return await preConfirm(value);
          } catch (err) {
            Swal.showValidationMessage(`Error: ${err.message}`);
            return false;
          }
        }
      : undefined,
    allowOutsideClick: () => !Swal.isLoading(),
  });

  return result.isConfirmed ? result.value : null;
};
